var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 20C9.66304 20 10.2989 19.7366 10.7678 19.2678C11.2366 18.7989 11.5 18.163 11.5 17.5H6.5C6.5 18.163 6.76339 18.7989 7.23223 19.2678C7.70107 19.7366 8.33696 20 9 20ZM10.2437 1.37374C10.2612 1.19994 10.242 1.0244 10.1875 0.858461C10.1329 0.69252 10.0442 0.539857 9.92697 0.410318C9.80978 0.280778 9.66675 0.177238 9.50709 0.106376C9.34742 0.0355132 9.17468 -0.00109863 9 -0.00109863C8.82532 -0.00109863 8.65258 0.0355132 8.49292 0.106376C8.33325 0.177238 8.19022 0.280778 8.07303 0.410318C7.95584 0.539857 7.8671 0.69252 7.81254 0.858461C7.75798 1.0244 7.7388 1.19994 7.75625 1.37374C6.3434 1.66112 5.07328 2.42795 4.16096 3.54437C3.24863 4.6608 2.75018 6.05821 2.75 7.49999C2.75 8.87249 2.125 15 0.25 16.25H17.75C15.875 15 15.25 8.87249 15.25 7.49999C15.25 4.47499 13.1 1.94999 10.2437 1.37374Z",
    fill: "#A0A9B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.7984e217458771631464e5cafd7dd201.svg";
export { ForwardRef as ReactComponent };